import React, { useEffect, useState } from 'react';
import { FaEye } from 'react-icons/fa';
import { getDentalActivityTimeline } from '../../../services/api/cashless-dentals';
import { getBlobUrl } from '../../../utils/getBlobUrlAndContentType';
import LoadingComponent from '../../common/LoadingComponent';

const getActorLabel = (entry) => {
  if (!entry.actorName) return null;
  if (entry.source === 'network_center_activities') return `Clinic: ${entry.actorName}`;
  if (entry.userType === 'user') return `User: ${entry.actorName}`;
  if (entry.userType === 'doctor') return `Doctor: ${entry.actorName}`;
  if (entry.userType === 'ops') return `Ops: ${entry.actorName}`;
  return `Agent: ${entry.actorName}`;
};

const formatDate = (isoString) => {
  if (!isoString) return '';
  const d = new Date(isoString);
  const dd = String(d.getDate()).padStart(2, '0');
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const yyyy = d.getFullYear();
  const hh = String(d.getHours()).padStart(2, '0');
  const min = String(d.getMinutes()).padStart(2, '0');
  return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
};

const AppointmentTimeline = ({ requestId }) => {
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!requestId) return;
    setLoading(true);
    getDentalActivityTimeline(requestId)
      .then((res) => {
        setHistory(Array.isArray(res) ? res : []);
      })
      .catch((err) => {
        console.error('[AppointmentTimeline]', err);
        setHistory([]);
      })
      .finally(() => setLoading(false));
  }, [requestId]);

  if (loading) {
    return <LoadingComponent />;
  }

  if (history.length === 0) {
    return (
      <div style={{ color: '#999', fontSize: '1rem', padding: '1rem 0' }}>
        No timeline events found.
      </div>
    );
  }

  return (
    <div>
      <div style={{ fontWeight: '700', fontSize: '1.1rem', color: '#4b4f5b', marginBottom: '0.75rem' }}>
        Timeline
      </div>
      <div style={{ position: 'relative', paddingLeft: '1.5rem' }}>
        {history.map((entry, index) => {
          const actorLabel = getActorLabel(entry);
          const isLast = index === history.length - 1;
          return (
            <div key={index} style={{ display: 'flex', flexDirection: 'column', marginBottom: '1.25rem', position: 'relative' }}>
              {/* Circle dot */}
              <div style={{
                position: 'absolute',
                left: '-1.5rem',
                top: '4px',
                width: '14px',
                height: '14px',
                borderRadius: '50%',
                border: '2px solid #6C5DD3',
                backgroundColor: '#fff',
                flexShrink: 0,
                zIndex: 1,
              }} />
              {/* Vertical connector line */}
              {!isLast && (
                <div style={{
                  position: 'absolute',
                  left: '-1.5rem',
                  top: '18px',
                  marginLeft: '6px',
                  width: '2px',
                  bottom: '-1.25rem',
                  backgroundColor: '#d0cce8',
                }} />
              )}
              <div>
                <div style={{ fontWeight: '600', fontSize: '0.95rem', color: '#222' }}>
                  {entry.description || 'Activity'}
                </div>
                <div style={{ fontSize: '0.82rem', color: '#666', marginTop: '2px' }}>
                  {formatDate(entry.createdAt)}
                </div>
                {actorLabel && (
                  <div style={{ fontSize: '0.82rem', color: '#555', marginTop: '2px' }}>
                    {actorLabel}
                  </div>
                )}
                {entry.attachments && entry.attachments.length > 0 && (
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '6px' }}>
                    {entry.attachments.map((att, attIdx) => (
                      <div
                        key={attIdx}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          background: '#f0edf8',
                          border: '1px solid #c9bfed',
                          borderRadius: '6px',
                          padding: '4px 8px',
                          cursor: 'pointer',
                          maxWidth: '130px',
                        }}
                        onClick={async () => {
                          const url = await getBlobUrl(att.url);
                          window.open(url, '_blank');
                        }}
                      >
                        <FaEye size={13} style={{ color: '#6C5DD3', flexShrink: 0 }} />
                        <span style={{
                          marginLeft: '5px',
                          fontSize: '0.78rem',
                          color: '#6C5DD3',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                        }}>
                          {att.name}
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AppointmentTimeline;
